// extracted by mini-css-extract-plugin
module.exports = {"title":"Project-module--title--2P804","blocks":"Project-module--blocks--4baAS"};